import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sanitation-routes--show"
export default class extends Controller {
  static targets = [];

  connect() {
    // Initialize with current URL params
    this.selectedFields = new Set(
      new URLSearchParams(window.location.search).getAll("filter_fields[]")
    );
  }

  toggleFilter(event) {
    const fieldId = event.currentTarget.dataset.fieldId;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Toggle the field in our selected set
    if (this.selectedFields.has(fieldId)) {
      this.selectedFields.delete(fieldId);
    } else {
      this.selectedFields.add(fieldId);
    }

    // Clear existing filter params
    params.delete("filter_fields[]");

    // Add current selection
    this.selectedFields.forEach((id) => {
      params.append("filter_fields[]", id);
    });

    // Update URL and reload page
    url.search = params.toString();
    Turbo.visit(url.toString());
  }
}
